import {
	JEET_11_PARTNER,
	JEET_11_DISTRIBUTOR,
	JEET_11_EXECUTIVE,
	JEET_11_CAPTAIN,
	JEET_11_PROMOTER,
	JEET_11_TSM,
	JEET_11_RBM,
	JEET_11_AGENT,
	JEET_11_SHOPBOY,
	JEET_11_ONLINE_DSTR,
	JEET_11_ONLINE_EXECUTIVE,
	JEET_11_ONLINE_RETAILER
} from "@/store/config";
import { HEAD_ON_BG_COLORS } from "./components/constants";

export const _checkValidHandle = handleName => {
	const handleRegexStr = "^[0-9a-zA-Z_]+$";
	const handleRegex = new RegExp(handleRegexStr);
	if (handleName && handleName.toString().match(handleRegex)) {
		if (Number.isNaN(Number(handleName))) {
			return true;
		}
	}
	return "Only alphanumeric chars are allowed!";
};

export const _checkValidHostName = str => {
	if (_onlyAplhabetsAndSpaces(str)) {
		return true;
	}
	return "Enter a valid name";
};

export const _onlyAplhabetsAndSpaces = str => {
	const regex = /^[a-zA-Z\s]*$/;
	if (regex.test(str.trim())) {
		return true;
	}
	return false;
};

export const _checkValidEmail = email => {
	if (email) {
		const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return pattern.test(email) || "Invalid e-mail.";
	}
	return true;
};

export const _onlyDigitsRule = (v, allowDecimals) => {
	return (
		!!allowDecimals ||
		v === null ||
		!/\D/g.test(v) ||
		"Only integers are allowed"
	);
};

export const _ageRule = (v, minAge, maxAge) => {
	return (
		v === null ||
		(!/\D/g.test(v) && minAge <= Number(v) && Number(v) < maxAge) ||
		`Age should be between ${minAge} and ${maxAge}`
	);
};

export const _validPhoneNoRule = v =>
	/^\d{10}$/.test(v) || "Write 10 digits phone number";

export const checkPhoneNumberValidity = v => /^\d{10}$/.test(v);

export const _requiredRule = value => {
	return (
		value === null ||
		(typeof value === "string" && !!value.trim()) ||
		"This is required"
	);
};

export const validIFSC = val => /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/.test(val);

export const checkValidPAN = string => {
	const PANRegex = /^[A-Z]{3}[ABCFGHLJPT]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}?$/;
	return string ? PANRegex.test(string) : true;
};

export const ALL_LANGUAGE_NAMES = [
	"Hindi",
	"Tamil",
	"Punjabi",
	"Telugu",
	"Malayalam",
	"Kannada",
	"Haryanvi",
	"Assamese",
	"Rajasthani",
	"Bhojpuri",
	"Gujarati",
	"Bengali",
	"Odia",
	"Marathi",
	"Bangladeshi"
];

export const themeInputColor = "#233B5D";

export const __getContactFormat = (str, areaCode) => {
	if (
		typeof str === "string" &&
		areaCode.length &&
		str.indexOf(areaCode) !== -1
	) {
		return `+${areaCode}-${str.substr(areaCode.length)}`;
	}
	return str;
};

export const __getDateFormat = str => {
	let today = new Date(parseInt(str, 10));
	let month = today.getMonth() + 1;
	month = month < 10 ? `0${month}` : month;
	let date = today.getDate();
	date = date < 10 ? `0${date}` : date;
	let strDate = "Y-m-d"
		.replace("Y", today.getFullYear())
		.replace("m", month)
		.replace("d", date);
	return strDate;
};

export const __whoCanFollowMe = [
	{ name: "Public", value: 0 },
	{ name: "Mutual followers", value: 1 },
	{ name: "All followers", value: 2 },
	{ name: "No one", value: 3 }
];

export const _getAuthorPic = obj =>
	typeof obj === "object"
		? obj.S
		: "http://www.uidownload.com/files/2/183/617/user-avatar-icon.png";

export const _getSafeStr = obj =>
	typeof obj === "object" ? obj.S : "Server Error";

export const ADULT_TAG_LIST = [
	97212,
	97270,
	97176,
	3549,
	23911,
	97407,
	101439,
	97438,
	97318,
	97266,
	97267,
	7939,
	17774,
	97306,
	97406,
	102980,
	102979,
	111518,
	111517,
	111606,
	111605
];

export const getHashtagId = post => {
	if ("tags" in post && "M" in post.tags) {
		let tags = Object.keys(post.tags.M);
		return window.parseInt(tags[0], 10) || 0;
	}
	return 0;
};

export const getHashtag = (post, noHashTag) => {
	let str = "";
	if ("tags" in post && "M" in post.tags) {
		Object.keys(post.tags.M)
			.map(key => post.tags.M[key])
			.forEach(tag => {
				str += noHashTag ? `${tag.S} ` : `#${tag.S} `;
			});
	}
	return str;
};

export const POST_STATUS = {
	DISCARDED: 0,
	PENDING: 1,
	APPROVED: 2
};

export const getHashCode = str => {
	let hash = 0;
	let i = 0;
	let len = str.length;

	while (i < len) {
		hash = ((hash << 5) - hash + str.charCodeAt(i++)) << 0;
	}
	return hash + 2147483647 + 1;
};

export const getImageSrc = (url, bypassPreFetch, preFetchImages) => {
	if (bypassPreFetch) return url;

	const hash = getHashCode(url);
	// let post_thumb = ""
	// if (post.thumbByte) {
	// 	post_thumb = "data:image/jpeg;base64," + post.thumbByte.S
	// } else {
	// 	post_thumb = "/static/show-loading.gif"
	// }
	// return preFetchImages[hash] ? url : post_thumb
	return preFetchImages[hash] ? url : null;
};

export const REGION_TYPE = {
	STATE: "state",
	CITY: "city",
	MICRO_MARKET: "micro_market"
};

export const PANEL_DATA = [
	{
		name: "Home",
		icon: "money",
		url: "/jeet11",
		routeName: "jeet11",
		requiresJEET11PartnerAccess: true,
		requiresJEET11PromoterAccess: true,
		requiresJEET11CaptainAccess: true
	},
	{
		name: "Jeet 11",
		icon: "money",
		url: "/jeet11distributor",
		routeName: "jeet11distributor",
		requiresJEET11DistributorAccess: true
	},
	// {
	// 	name: "Profile",
	// 	icon: "perm_identity",
	// 	url: "/profile",
	// 	routeName: "profile",
	// 	requiresRetailAccess: true,
	// 	requiresJEET11DistributorAccess: true,
	// 	requiresJEET11TSMAccess: true,
	// 	requiresJEET11PartnerAccess: true,
	// 	requiresJEET11CaptainAccess: true,
	// 	requiresJEET11RBMAccess: true,
	// 	requiresSomeAccess: true
	// },
	// {
	// 	name: "My Associates",
	// 	icon: "people",
	// 	url: "/my-associates",
	// 	routeName: "associates"
	// },
	// {
	// 	name: "Task/Review Section",
	// 	icon: "list",
	// 	url: "/task-review-section",
	// 	routeName: "task-review-section"
	// },
	// {
	// 	name: "Week Planning",
	// 	icon: "list",
	// 	url: "/week-planning",
	// 	routeName: "week-planning"
	// },
	// {
	// 	name: "Location Review",
	// 	icon: "list",
	// 	url: "/location-review",
	// 	routeName: "location-review"
	// },
	// {
	// 	name: "Visit History",
	// 	icon: "list",
	// 	url: "/visit-history",
	// 	routeName: "visit-history"
	// },
	// {
	// 	name: "Review",
	// 	icon: "person",
	// 	url: "/review",
	// 	routeName: "review",
	// 	requiresRetailAdminAccess: true,
	// 	requiresJEET11RBMAccess: true
	// },
	// {
	// 	name: "Referral Section",
	// 	icon: "money",
	// 	url: "/referral",
	// 	routeName: "referral",
	// 	requiresRetailAccess: true
	// },
	// {
	// 	name: "Payment Section",
	// 	icon: "money",
	// 	url: "/payment",
	// 	routeName: "payment",
	// 	requiresRetailAccess: true
	// },
	// {
	// 	name: "Rank List",
	// 	icon: "list",
	// 	url: "/rank",
	// 	routeName: "rank",
	// 	requiresRetailAccess: true,
	// 	requiresRetailAdminAccess: true
	// },
	{
		name: "Invoice",
		icon: "money",
		url: "/invoice",
		routeName: "Invoice",
		requiresJEET11DistributorAccessOnly: true
	},
	// {
	// 	name: "Acknowledge Jeet 11 Payment",
	// 	icon: "money",
	// 	url: "/acknowledge",
	// 	routeName: "acknowledge",
	// 	requiresFinanceAdminAccess: true
	// },
	// {
	// 	name: "User Stories",
	// 	icon: "money",
	// 	url: "/user-stories",
	// 	routeName: "user-stories",
	// 	requiresSomeAccess: true
	// },
	// {
	// 	name: "Recharge History",
	// 	icon: "money",
	// 	url: "/recharge-history",
	// 	routeName: "recharge-history",
	// 	requiresJEET11PartnerAccess: true,
	// 	requiresJEET11PromoterAccess: true
	// },
	// {
	// 	name: "Reward Section",
	// 	icon: "money",
	// 	url: "/reward-section",
	// 	routeName: "reward-section",
	// 	requiresJEET11PartnerAccess: true
	// },
	// {
	// 	name: "User Profile",
	// 	icon: "money",
	// 	url: "/user-profile",
	// 	routeName: "user-profile"
	// },
	// {
	// 	name: "Manage Distributors",
	// 	icon: "person",
	// 	url: "/manage-distributors",
	// 	routeName: "manage-distributors",
	// 	requiresFinanceAdminAccess: true
	// },
	{
		name: "TSM Dashboard",
		icon: "list",
		url: "/tsm",
		routeName: "tsm",
		requiresJEET11TSMAccess: true
	},
	{
		name: "RBM Dashboard",
		icon: "list",
		url: "/rbm",
		routeName: "rbm",
		requiresJEET11RBMAccess: true
	},
	// {
	// 	name: "Distribute Rewards",
	// 	icon: "money",
	// 	url: "/distribute-rewards",
	// 	routeName: "distribute-rewards",
	// 	requiresFinanceAdminAccess: true
	// },
	// {
	// 	name: "User History",
	// 	icon: "money",
	// 	url: "/user-history",
	// 	routeName: "user-history"
	// },
	// {
	// 	name: "Schemes",
	// 	icon: "list",
	// 	url: "/schemes",
	// 	routeName: "schemes",
	// 	requiresJEET11PartnerAccess: true,
	// 	requiresJEET11PromoterAccess: true,
	// 	requiresJEET11DistributorAccess: true
	// },
	// {
	// 	name: "Commission Dashboard",
	// 	icon: "money",
	// 	url: "/dstr-commission-dashboard",
	// 	routeName: "dstr-commission-dashboard",
	// 	requiresJEET11DistributorAccessOnly: true
	// },
	// {
	// 	name: "Commission Dashboard",
	// 	icon: "money",
	// 	url: "/retailer-commission-dashboard",
	// 	routeName: "retailer-commission-dashboard",
	// 	requiresNewSchemeRetailAccess: true
	// },
	// {
	// 	name: "Commission Payout",
	// 	icon: "money",
	// 	url: "/commission-payout",
	// 	routeName: "commission-payout",
	// 	requiresNewSchemeDstrAccessFantasy: true
	// },
	{
		name: "Rummy",
		icon: "money",
		url: "/rummy-dstr",
		routeName: "rummy-dstr",
		requiresJEET11DistributorAccess: true
	},
	{
		name: "Rummy",
		icon: "money",
		url: "/rummy",
		routeName: "rummy",
		requiresJEET11PartnerAccess: true,
		requiresJEET11PromoterAccess: true
	},
	// {
	// 	name: "Reward Section",
	// 	icon: "money",
	// 	url: "/reward-section-rummy",
	// 	routeName: "reward-section-rummy",
	// 	requiresJEET11PartnerAccess: true
	// },
	// {
	// 	name: "Commission Dashboard(Rummy)",
	// 	icon: "money",
	// 	url: "/dstr-commission-dashboard-rummy",
	// 	routeName: "dstr-commission-dashboard-rummy",
	// 	requiresJEET11DistributorAccessOnly: true
	// },
	// {
	// 	name: "Commission Dashboard(Rummy)",
	// 	icon: "money",
	// 	url: "/retailer-commission-dashboard-rummy",
	// 	routeName: "retailer-commission-dashboard-rummy",
	// 	requiresNewSchemeRetailAccess: true
	// },
	// {
	// 	name: "Commission Payout (Rummy)",
	// 	icon: "money",
	// 	url: "/commission-payout-rummy",
	// 	routeName: "commission-payout-rummy",
	// 	requiresNewSchemeDstrAccessCardGames: true
	// },
	// {
	// 	name: "Update Schemes",
	// 	icon: "list",
	// 	url: "/update-schemes",
	// 	routeName: "update-schemes",
	// 	requiresRetailAdminAccess: true
	// },
	// {
	// 	name: "DSTR Support Invoice",
	// 	icon: "list",
	// 	url: "/dstr-support-invoice",
	// 	routeName: "dstr-support-invoice",
	// 	requiresRetailAdminAccess: true
	// },
	{
		name: "DSTR Support Invoice",
		icon: "list",
		url: "/dstr-support-invoice-finance",
		routeName: "dstr-support-invoice-finance",
		requiresFinanceAdminAccess: true
	},
	{
		name: "DSTR GST Invoice",
		icon: "list",
		url: "/dstr-gst-invoice-finance",
		routeName: "dstr-gst-invoice-finance",
		requiresFinanceAdminAccess: true
	},
	{
		name: "Review",
		icon: "person",
		url: "/review-finance",
		routeName: "review-finance",
		requiresFinanceAdminAccess: true
	},
	{
		name: "Invoice Numbers",
		icon: "money",
		url: "/invoice-numbers",
		routeName: "invoice-numbers",
		requiresAgencyAccess: true
	}
	// {
	// 	name: "Metrics",
	// 	icon: "list",
	// 	url: "/metrics",
	// 	routeName: "metrics"
	// },
	// {
	// 	name: "QR Code",
	// 	icon: "code",
	// 	url: "/qrCode",
	// 	routeName: "qrCode"
	// },
	// {
	// 	name: "Notification Tool",
	// 	icon: "list",
	// 	url: "/notifications",
	// 	routeName: "notifications"
	// },
	// {
	// 	name: "Leaderboards",
	// 	icon: "list",
	// 	url: "/all-leaderboards",
	// 	routeName: "leaderboards"
	// }
];

export const __normalizeNumber = num => {
	if (Number.isNaN(num)) return 0;
	if (num >= 1000000) return __getRounded(num / 1000000) + "m";
	if (num >= 1000) return __getRounded(num / 1000) + "k";
	return num;
};

const __getRounded = n => Math.round(n * 10) / 10;

export const __fileDownload = src => {
	let a = document.createElement("a");
	a.href = src;
	a.download = src.split("/").pop();
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
};

export const _getVerifiedIcon = status => {
	if (typeof status === "string") {
		status = parseInt(status, 10);
	}
	switch (status) {
		case 1:
			return "tick_icon_blue";
		case 4:
			return "sharechat_police";
		case 3:
			return "sharechat_medal";
	}
	return "";
};

export const _getDateTimeFormat = timeStamp => {
	const date = new Date(timeStamp);
	return `${date.toLocaleDateString()}, ${date.toLocaleTimeString()}`;
};

export const _checkDecimalFormat = v => {
	const regex = new RegExp(/^\d+(\.\d{1,2})?$/);
	return regex.test(v);
};

export const possibleReferrers = ["RBM", "TSM", "SE", "RTLR", "Captain"];

export const SHARE_LINK_WHATSAPP = "https://api.whatsapp.com/send?text=";

export function openExternalLink(url, openInNewTab) {
	const link = document.createElement("a");
	if (openInNewTab) {
		link.target = "_blank";
	}

	link.rel = "noopener noreferrer";
	link.href = url;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

export function createShareOnWhatsAppLinkWithoutReferrer(
	link,
	text = "",
	phoneNo
) {
	let sharingLink = `${SHARE_LINK_WHATSAPP}${window.encodeURIComponent(
		`${text}`
	)}${window.encodeURIComponent(link)}`;
	if (phoneNo) {
		sharingLink += `&phone=${phoneNo}`;
	}
	return sharingLink;
}

export function shareOnWhatsapp(link, text, phoneNo) {
	openExternalLink(
		createShareOnWhatsAppLinkWithoutReferrer(link, text, phoneNo),
		true
	);
}

export const supportsPushNotification = () =>
	"Notification" in window && navigator.serviceWorker;

export const getNotificationPermission = () => {
	return Notification.requestPermission().then(result => {
		return result;
	});
};

export const getHeadOnUserBackgroundColor = (userId = "") => {
	const numbersFromUserId = (userId || "").match(/\d+/);
	const colorIndex = numbersFromUserId % HEAD_ON_BG_COLORS.length;
	return HEAD_ON_BG_COLORS[colorIndex];
};

export const getOrdinalNumber = number => {
	if (number > 3 && number < 21) return "th";
	switch (number % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
};

export const getReadableAmount = amount => {
	if (amount >= 100000) return String((amount / 100000).toFixed(2)) + "L";
	else if (amount >= 1000) return String((amount / 1000).toFixed(2)) + "K";
	else return String(Number(amount).toFixed(2));
};

export const dd_mm_yyToyy_mm_dd = date => {
	const [d, m, y] = date.split("-");
	return `${y}-${m}-${d}`;
};

export const getFrontendStoreType = (val, shopType) => {
	if (val === "dstrRetail") {
		if (shopType === "agent") {
			return JEET_11_AGENT;
		}
		if (shopType === "shopboy") {
			return JEET_11_SHOPBOY;
		}
		if (shopType === "online") {
			return JEET_11_ONLINE_RETAILER;
		}
		return JEET_11_PARTNER;
	}
	if (val === "dstr") {
		if (shopType === "online") {
			return JEET_11_ONLINE_DSTR;
		}
		return JEET_11_DISTRIBUTOR;
	}
	if (val === "executive") {
		if (shopType === "online") {
			return JEET_11_ONLINE_EXECUTIVE;
		}
		return JEET_11_EXECUTIVE;
	}
	if (val === "captain") {
		return JEET_11_CAPTAIN;
	}
	if (val === "promoter") {
		return JEET_11_PROMOTER;
	}
	if (val === "tsm") {
		return JEET_11_TSM;
	}
	if (val === "rbm") {
		return JEET_11_RBM;
	}
	return val;
};

export const convertToReadableForm = text => {
	const readableText = text
		.split("_")
		.reduce(
			(acc, curr) =>
				`${acc} ${curr[0].toUpperCase()}${curr.substring(1)}`,
			""
		);
	return readableText;
};

export const keysFilteration = (keysArray, keysToBeFiltered) => {
	return keysArray.filter(item => {
		const itemLowerCase = item.toLowerCase();
		return !keysToBeFiltered.some(key => itemLowerCase.includes(key));
	});
};

export const promptToDownloadFile = (url, fileName = "") => {
	const link = document.createElement("a");
	link.href = url;
	link.download = fileName || true;

	if (document.createEvent) {
		const evt = document.createEvent("MouseEvents");
		evt.initMouseEvent(
			"click",
			true,
			true,
			window,
			0,
			0,
			0,
			0,
			0,
			false,
			false,
			false,
			false,
			0,
			null
		);
		link.dispatchEvent(evt);
	} else if (document.createEventObject) {
		const evt = document.createEventObject();
		link.fireEvent("onclick", evt);
	} else {
		document.body.appendChild(link); // Required for FF
		link.click();
		document.body.removeChild(link);
	}
};

export function degreesToRadians(degrees) {
	return (degrees * Math.PI) / 180;
}

export function getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
	let R = 6371071;
	let dLat = degreesToRadians(lat2 - lat1);
	let dLong = degreesToRadians(lng2 - lng1);
	let a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(degreesToRadians(lat1)) *
			Math.cos(degreesToRadians(lat1)) *
			Math.sin(dLong / 2) *
			Math.sin(dLong / 2);

	let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	let distance = R * c;

	return distance;
}
export const downloadArrayAsCsv = (array, fileName = "File") => {
	const csvContent = `data:text/csv;charset=utf-8,${array
		.map(row => row.join(","))
		.join("\n")}`;
	const encodedUri = encodeURI(csvContent);
	const link = document.createElement("a");
	link.setAttribute("href", encodedUri);
	link.setAttribute("download", `${fileName}.csv`);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

export const getCsvRows = (data, keyValueMap, keysToRound) => {
	const result = data.reduce((arr, row) => {
		const currentRow = [];
		for (const key in keyValueMap) {
			const toRound = keysToRound.includes(keyValueMap[key]);
			currentRow.push(
				toRound
					? Math.round(row[keyValueMap[key]])
					: String(row[keyValueMap[key]]).replace(/[@#,";]/g, "")
			);
		}
		arr.push([currentRow.join(",")]);
		return arr;
	}, []);

	return result;
};
